import * as z from "zod/v4";

export const triggerManualValidation = {
  name: "triggerManualValidation" as const,
  input: z.object({
    /** Linear ticket identifier (e.g., "RETCO-8304") */
    identifier: z.string(),
    /** Force re-validation even if ticket already has validation comment */
    force: z.boolean().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    ticketId: z.string().nullable(),
    identifier: z.string().nullable(),
  }),
};
